import { combineReducers } from 'redux';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';

import { teamFilterReducerFactories } from 'media-base-ui/redux/utils';
import actionTypes from './actionTypes';

/* State shape
 {
    loadingState: {
     gameType: {
        isLoading: bool,
        success: bool,
        error: Object
     },
     report: {
        isLoading: bool,
        success: bool,
        error: Object
     }
    },
    reportsState: {
        gameTypeData: Array,
        prior: bool,
        penaltyShot: bool,
        shootout: bool
    }
 }
 */

const gameTypeLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_GAMETYPE_DATA)(actionTypes.GAMETYPE_DATA_RESPONSE);
const reportLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_REPORT_DATA)(actionTypes.REPORT_DATA_RESPONSE);
const selectedTeamsReducer = teamFilterReducerFactories.selectedTeamsReducerFactory
                                (actionTypes.CHANGE_TEAM_SELECTION)
                                (actionTypes.CHANGE_DIVISION_SELECTION)
                                (actionTypes.CHANGE_CONFERENCE_SELECTION)
                                (actionTypes.CHANGE_ALL_SELECTION)
                                ()
                                (actionTypes.HYDRATE_TEAM_FILTER);

const selectedReportsReducer = (state = [], action) => {
    const { payload } = action || {};

    if(action.type === actionTypes.CHANGE_REPORT_SELECTION){

        let selections = state.slice(0);

        if(payload.isChecked){
            if(!payload.selectedReports.find((report) => report.reportType === payload.reportType)) {
                selections.push({ reportType: payload.reportType, isChecked: payload.isChecked});
            }
            return selections;
        } else {
            return selections.filter(el => el.reportType !== payload.reportType);
        }
    }

    return state;
};


const reportUrlReducer = (state = '', action) => {
    const { payload } = action;
    if (action.type === actionTypes.REPORT_DATA_RESPONSE) {
        return payload.url;
    }
    return state;
};

const selectedGameTypeReducer = (state = null, action) => {
    const { payload } = action;

    if(action.type === actionTypes.CHANGE_GAMETYPE_VALUE){
        return payload;
    }

    return state;
};

const gameTypeReducer = (state = 0, action) => {
    const { payload } = action;

    if (action.type === actionTypes.GAMETYPE_DATA_RESPONSE) {
        return payload.gameTypeData;
    }
    return state;

};

const loadingStateReducer = combineReducers({
    gameType: gameTypeLoadingStateReducer,
    report: reportLoadingStateReducer
});

const reportsStateReducer = combineReducers({
    selectedTeams: selectedTeamsReducer,
    selectedReports: selectedReportsReducer,
    gameTypeData: gameTypeReducer,
    selectedGameType: selectedGameTypeReducer,
    reportUrl: reportUrlReducer,
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    reportsState: reportsStateReducer
});

export default reducer;